import * as stylex from "@stylexjs/stylex";
import { cloneElement, type AnchorHTMLAttributes, type ReactElement, type ReactNode } from "react";
import "../tokens.stylex.ts";
import { color } from "../tokens.stylex.ts";

/** Inline link. Pass `render` to use a router link; otherwise renders `<a>`. */
export function TextLink({
  render,
  children,
  ...rest
}: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "className" | "style"> & {
  render?: ReactElement<{
    className?: string;
    children?: ReactNode;
  }>;
}) {
  const props = {
    className: "x1rizfjd xujl8zx xtun9c1 x1fkgj8t xyi4chj xda060z xeirdtl xgdialr x1ypdohk"
  };
  if (render) return cloneElement(render, {
    ...rest,
    ...props,
    children
  });
  return <a {...rest} {...props}>
      {children}
    </a>;
}